import { api, newIdempotencyKey, withIdempotencyKey } from './client'

/** Un modulo Ermes applicabile alla pratica, con lo stato dei documenti gia' presenti. */
export interface ErmesModuleStatus {
  kind: string
  label: string
  /** DocumentType con cui ricaricare la copia firmata (es. "Ermes - Modulo IVA 10% luce (firmato)"). */
  signedDocumentType: string
  generated: boolean
  signed: boolean
  generatedDocumentId: number | null
  generatedAt: string | null
  signedDocumentId: number | null
  signedAt: string | null
  /** Dati obbligatori che il CRM non ha (etichette in italiano). */
  missingFields: string[]
}

export interface ErmesModulesResponse {
  isErmes: boolean
  modules: ErmesModuleStatus[]
  /** Scheda cliente collegata alla pratica, se c'e'. */
  customerId: number | null
}

export const ermesModulesApi = {
  list: (contractId: number) => api<ErmesModulesResponse>(`/api/contracts/${contractId}/ermes-modules`),
  generate: (contractId: number, kind: string) =>
    api<{ id: number; name: string }>(`/api/contracts/${contractId}/ermes-modules/${encodeURIComponent(kind)}`, withIdempotencyKey({ method: 'POST' }, newIdempotencyKey())),
}
